import {Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {Card, Edition, PriceRule} from '../../core/entities/entities';
import {CardService} from '../../services/card.service';
import {LanguageService} from '../../services/language.service';
import {WarehouseService} from '../../services/warehouse.service';
import {ToastrService} from 'ngx-toastr';
import {TypeaheadMatch} from 'ngx-bootstrap';
import {ActivatedRoute, Router} from '@angular/router';
import {EditionService} from '../../services/edition.service';
import {CardConditionService} from '../../services/card-condition.service';
import {PriceRuleService} from '../../services/price-rule.service';
import {PriceRuleAddComponent} from '../price-rule-add/price-rule-add.component';
import {NgForm} from '@angular/forms';

@Component({
  selector: 'app-price-rule-detail',
  templateUrl: './price-rule-detail.component.html',
  styleUrls: ['./price-rule-detail.component.css']
})
export class PriceRuleDetailComponent extends PriceRuleAddComponent implements OnInit {

  @ViewChild('rapidForm') rapidForm: NgForm;


  selectedEditions: Edition[] = [];

  private origItem : PriceRule;
  constructor(_priceRuleService: PriceRuleService,
              _route: ActivatedRoute,
              _languageService: LanguageService,
              _warehouseService: WarehouseService,
              _cardConditionService: CardConditionService,
              _cardService: CardService,
              _editionServ: EditionService,
              _router: Router,
              _toastrService: ToastrService) {
    super(_priceRuleService, _route, _languageService, _warehouseService, _cardConditionService, _cardService, _editionServ, _router, _toastrService);
  }


  ngOnInit() {
    super.ngOnInit();
    const me = this;
    this.spinnerService.show();
    this._route.params.subscribe((params) => {


      if (params['brandId'] && params['categoryId']) {
        this.brandId = params['brandId'];
        this.categoryId = params['categoryId'];
      }

      me._priceRuleService.loadById(params['rule_id'], true).subscribe(ret =>{
        this.origItem = ret;
        me.item = me._priceRuleService.getDTOfromRule(ret);
        me.selectedEditions = me.item.editions;
        if(ret.product && ret.product.id){
          const card = new Card();
          card.name = ret.product.cardData ? ret.product.cardData.name : null;
          card.id = ret.product.id;
          card['category'] = ret.product['category'];
          card.imageName = ret.product.cardData ? ret.product.cardData.image : null;
          me.item.rarityId = [];

          me.selectCard( new TypeaheadMatch(card));
          me.item.cardId = ret.product.id;
        } else if ( ret.editionIdentifier){
          const edition = new Edition();
          edition.id = ret.editionIdentifier;
          edition.name = ret.edition;
          me.selectEdition(new TypeaheadMatch(edition));
        }
        this.spinnerService.hide();

      } );
    });
  }

  remove() {
    this.spinnerService.show();
    this._priceRuleService.remove(this.origItem).subscribe(ret => {this._toastrService.success('Eseguito Correttamente!') ; this._router.navigateByUrl('/home/price_rules')});
  }

  update() {

    this.item.editionId = this.selectedEditions.map( edition => edition.id);
    this.spinnerService.show();
    this.item.editionId = this.selectedEditions.map( ed => ed.id);
    this.item.categoryId = this.categoryId;
    this.item.brandId = this.brandId;
    this.clear(this.item);
    this._priceRuleService.save(this.item).subscribe(ret => {this._toastrService.success('Eseguito Correttamente!') ; this._router.navigateByUrl('/home/price_rules')});
  }

  onChecked(meta: string, checked: string) {
    console.log(checked);
    if (meta === 'maxRule') {
      if (checked === 'true' && this.item.price) {
        this.item.maxPrice = this.item.price;
      } if (checked !== 'true') {
        this.item.maxPrice = undefined;
      }
    } else if (meta === 'minRule') {
      if (checked !== 'true') {
        this.item.maxPrice = undefined;
        this.item['maxRule'] = false;
      }
    }
  }

  @HostListener('keydown.enter', ['$event'])
  onEnterKey(event: KeyboardEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.handleUpdate();
  }

  handleUpdate() {
    if (!this.currentProductStruct || !this.currentProductStruct.id || !this.rapidForm.form.valid) {
      return;
    }
    this.confirmAndUpdate();
  }

  confirmAndUpdate() {
    const confirmed = confirm('Sicuro di voler creare la regola?');
    if (confirmed) {
      this.update();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/conf/price-rule-detail/price-rule-detail.component.ts